import { defineComponent as _defineComponent } from 'vue'
import VModal from "@/components/vModal.vue";

type vUpsellModalProps = {
  showModal: boolean;
  message?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vUpsellModal',
  props: {
    showModal: { type: Boolean, default: false },
    message: { default: "This feature requires a paid subscription to use." }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { showModal: boolean, message: string };





return { __sfc: true,props, emit, VModal }
}

})